import { useEffect, useState } from 'react';
import { StreamChat } from 'stream-chat';

import { USER_BAN, USER_UNBAN } from '../consts/banConsts';
import { fetchUsersFromGetStream } from '../utils/user';

const useUserBanListener = (client: StreamChat) => {
    const [isMyUserBanned, setIsMyUserBanned] = useState<boolean>(false);

    useEffect(() => {
        if (client) {
            const updateMyUserBanned = async () => {
                const bannedUsers = await fetchUsersFromGetStream(client, {
                    banned: true,
                    id: client.user.id,
                });
                const myUserInBanList = bannedUsers.find(
                    user => user.providerId === client.user.id
                );
                setIsMyUserBanned(!!myUserInBanList);
            };
            updateMyUserBanned();
        }
    }, [client]);

    useEffect(() => {
        let clientListener = { unsubscribe: () => {} };

        if (client) {
            clientListener = client.on(event => {
                if (event.user) {
                    if (event.type === USER_BAN && client.user.id === event.user.id) {
                        setIsMyUserBanned(true);
                    }
                    if (event.type === USER_UNBAN && client.user.id === event.user.id) {
                        setIsMyUserBanned(false);
                    }
                }
            });
        }

        return () => {
            clientListener.unsubscribe();
        };
    }, [client]);

    return isMyUserBanned;
};

export default useUserBanListener;
